<div class="list-filters" [class.mobile]="rwdService.isSmallDevice">
  <div *ngIf="!isDefault" class="reset-filters" (click)="reset(true)">x {{ 'button.resetFilters' | loc }}</div>
  <app-filter-options *ngFor="let cfg of config" [config]="cfg" (option)="onFilterChange(cfg.key, $event)"> </app-filter-options>
</div>
